module.exports = __webpack_public_path__ + "img/logo-card-contact.d4105ff0.jpg";